var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.field.options.chartStyle != 2 || _vm.myOption.isNoData
    ? _c("myEcharts", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        attrs: {
          isShowEmpty: _vm.isShowEmpty,
          option: _vm.myOption,
          field: _vm.field,
          designer: _vm.designer,
        },
      })
    : _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "bar-progress",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.setSelected($event)
            },
          },
        },
        [
          _c("el-progress", {
            staticStyle: { width: "100%" },
            attrs: {
              "text-inside": true,
              "stroke-width": 36,
              percentage: _vm.percentage,
              format: _vm.formatText,
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }